var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Menu',{attrs:{"rol":1}}),_c('v-main',{staticClass:"appBackground"},[_c('Banner'),_c('v-scroll-x-transition',{attrs:{"mode":"out-in","hide-on-leave":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }